module.exports = __webpack_public_path__ + "app-exclusive-d56019770b00b746e4da.png";